import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const fadeWithMoveY = [
    trigger('fadeWithMoveY', [
        transition(':enter', [
          style({opacity: '0', position: 'relative', top: '-500px'}),
          animate('250ms', style({opacity: '1', position: 'relative', top: '0'}),),
        ]),
        transition(':leave', [
          style({opacity: '1',  position: 'relative', top: '0px'}),
          animate('150ms', style({opacity: '0',  position: 'relative', top: '-500px'}),),
        ])
    ])
]